<template>
  <div class="video-content">
    <div class="majorEvents-title">
      <div>项目简介</div>
      <!-- 视图展示内容控制-->
      <div @click="operation" class="operation">
        <i style="font-size: 20px" class="el-icon-connection"></i>
      </div>
    </div>
    <div style="display: flex;height: calc(100% - 25px)">
      <div class="video-content-item" style="border-right: 1px solid #eaeaea;padding-right: 10px">
        <div  >
          <span @click="getEventInfo" class="video-title">{{voidObj.TITLE_}}</span>
          <p class="video-detail">
            {{voidObj.BRIEF_INTRO}}
          </p>
        </div>
      </div>
      <div class="video-content-item " style="margin-left: 13px">
        <video
          autoplay="autoplay"
          loop="loop"
          muted="muted"
          width="100%"
          height="100%"
          :src="voidUrl"
          controls="controls">
        </video>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "videoDetail",
  props:['voidObj'],
  watch:{
    voidObj:{
      handler(oldVal,newVal) {
        console.log(oldVal,1111111111);
        this.getFilesSearch(oldVal.ID_)
      },
      deep:true,
      immediate:false
    }
  },
  data() {
    return {
      voidUrl:''
    }
  },
  methods:{
    getEventInfo() {
      window.open(`/calendarEventsInfo?id=${this.voidObj.ID_}&entityName=LOGIN_NEW_TRENDS`)
    },
    // 获取附件
    getFilesSearch(row) {
      // let host = window.location.host;
      this.$axios.post(`/api/fs/files/search?metaData.formId=${row}&metaData.fileType=voidUrl`).then(res => {
        if (res.status === 200) {
          res.data.forEach((item,index) => {
            item.name = item.filename
            item.url = `/api/fs/files/download/${item.id}`
          })
          this.voidUrl = res.data[0].url
        }
      });
    },
    operation() {
      this.$emit('operationVoid')
    },
  }
}
</script>

<style scoped>
.video-content {
  height: 100%;
  border-radius: 5px;
  font-size: 14px;
  box-sizing: border-box;
  border: 2px solid #eaeaea;
  padding: 15px;
}
.video-content-item {
  width: 50%;
  box-sizing: border-box;
  overflow: hidden;
}
.majorEvents-title {
  font-weight: 600;
  margin-bottom: 10px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.font-style {
  font-weight: 600;
  margin-bottom: 10px;
  position: relative;
  z-index: 9;
  background-color: #fff;
}
.video-title{
  font-weight: 600;
  margin-bottom: 10px;
  display: block;
  text-decoration: underline;
}
.video-title:hover {
  text-decoration: underline;
  cursor: pointer;
}
.video-frame-title {
  margin-top: 5px;
  color: #999999;
  font-size: 12px;
  display: flex;
  justify-content: space-between;
}
p {
  margin-top: 10px;
  text-indent: 2em;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
}
video {
  background-color: black;
  overflow:hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/pageConfig/videoDetail.vue